import { render } from "./ImagesSlider.vue?vue&type=template&id=4c11226b&scoped=true"
import script from "./ImagesSlider.vue?vue&type=script&lang=js"
export * from "./ImagesSlider.vue?vue&type=script&lang=js"

import "./ImagesSlider.vue?vue&type=style&index=0&id=4c11226b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c11226b"]])

export default __exports__